import React from 'react'
import { observer } from 'mobx-react'
import { TeamItemViewModel } from './TeamItemViewModel'
import Avatar from 'components/Avatar'
import link from 'infra/link'
import {
  SplitViewSidebarListItem,
  SplitViewSidebarListItemArrow,
  SplitViewSidebarListItemTitle,
  SplitViewSidebarListItemSubtitle,
} from 'components/SplitView'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: TeamItemViewModel
  active?: boolean
}

export default observer(function TeamItem({ vm, active }: Props) {
  return (
    <SplitViewSidebarListItem
      to={vm.team.slug ? link.team(vm.team.slug) : ''}
      active={active}
      extras={<SplitViewSidebarListItemArrow />}
      visual={
        <Avatar
          size={32}
          subject={{
            avatar: vm.team.avatar,
            displayName: vm.team.name,
          }}
        />
      }
    >
      <SplitViewSidebarListItemTitle>
        {vm.team.name}
      </SplitViewSidebarListItemTitle>
      <SplitViewSidebarListItemSubtitle>
        Owner: {vm.teamOwner.member.displayName}
      </SplitViewSidebarListItemSubtitle>
    </SplitViewSidebarListItem>
  )
})
